import { createGlobalState, useLocalStorage } from '@vueuse/core';

// Source card is hidden by default and toggled from the conversation side panel switch.
export const useSourceCardVisibility = createGlobalState(() => {
  const isOpen = useLocalStorage('multichat.sourceCard.open', false);
  const toggle = () => {
    isOpen.value = !isOpen.value;
  };
  return { isOpen, toggle };
});
